import { useEffect, useState } from 'react';
import { pricing as pricingApi } from '@afosto/order/api/Pricing';

const useAdjustments = adjustment => {
  const [pricingRule, setPricingRule] = useState(null);

  /**
   * Fetch pricing rule.
   * @param {string} ruleID
   * @returns {Promise<void>}
   */
  const fetchPricingRule = async ruleID => {
    try {
      const response = await pricingApi.getPricingRule(ruleID);
      const { data } = response;

      setPricingRule(data);
    } catch (err) {
      setPricingRule(null);
    }
  };

  useEffect(() => {
    if (adjustment) {
      const { metadata = {} } = adjustment;

      if (metadata.rule_id) {
        fetchPricingRule(metadata.rule_id);
      }
    }
  }, [adjustment]);

  /**
   * Return the adjustment name.
   * @returns {string}
   */
  const getAdjustmentName = () => {
    if (pricingRule) {
      return adjustment.is_percentage
        ? `${pricingRule.name} (${adjustment.amount}%)`
        : pricingRule.name;
    }

    return adjustment.is_percentage
      ? `${adjustment.description} (${adjustment.amount}%)`
      : adjustment.description;
  };

  const currencyAmount = adjustment.is_discount
    ? (adjustment.result.output / 100) * -1
    : adjustment.result.output / 100;

  return [getAdjustmentName(), currencyAmount];
};

export default useAdjustments;
